import client from "../client";
import { PaginationRequest } from "src/types/commonTypes";

export interface SearchExpensesRequest extends PaginationRequest {
  filter?: {
    expense_filter: {
      expense_ids?: string[];
      expense_date?: {
        min?: string;
        max?: string;
      };
      object_id?: string;
    };
  };
}
export type CreateExpenseRequest = {
  title: string;
  description: string;
  object_id: string;
  object_type: string;
  expense_date: string;
  expense_type: string;
  expense_category: string;
  expense_done_by: string;
};

export type UpdateExpenseRequest = {
  expense_id: string;
  title: string;
  description: string;
  expense_date: string;
  expense_category: string;
  expense_done_by: string;
};

export type ToggleExpenseStatusRequest = {
  expense_id: string;
  is_active: boolean;
};

export type GroupWalletTransferRequest = {
  expense_id: string;
  sources: {
    amount: number;
    wallet_id: string;
  }[];
  destinations: {
    amount: number;
    wallet_id: string;
  }[];
};

export type ConnectUserToExpenseRequest = {
  expense_id: string;
  user_id: string;
  amount: number;
};

export type RemoveUserFromExpenseRequest = {
  expense_id: string;
  user_id: string;
};

export const searchExpenses = (input: SearchExpensesRequest) => {
  return client({
    query: `query SearchExpenses($input: SearchInput) {
      search_expense(input: $input) {
        total_pages
        total_size
        items {
           organisation_id
           title
           description
           expense_id
           object_id
           object_type
           status
           display_id
           expense_date
           expense_type
           expense_category
           expense_done_by
           
        }
      }
    }`,
    variables: {
      input: input
    }
  });
};

export const getExpenseDetail = (expense_id: string) => {
  return client({
    query: `query GetExpense($input: GetExpenseInput) {
      get_expense(input: $input) {
        organisation_id
        title
        description
        expense_id
        object_id
        object_type
        status
        display_id
        expense_date
        expense_type
        expense_category
        expense_done_by
      }
    }`,
    variables: {
      input: {
        expense_id: expense_id
      }
    }
  });
};

export const createExpense = (input: CreateExpenseRequest) => {
  return client({
    query: `mutation CreateExpense($input: CreateExpenseInput) {
      create_expense(input: $input) {
        expense_id
      }
    }`,
    variables: {
      input: input
    }
  });
};

export const updateExpense = (input: UpdateExpenseRequest) => {
  return client({
    query: `mutation UpdateExpense($input: UpdateExpenseInput) {
      update_expense(input: $input) {
        expense_id
      }
    }`,
    variables: {
      input: input
    }
  });
};

export const toggleExpenseStatus = (input: ToggleExpenseStatusRequest) => {
  return client({
    query: `mutation ToggleExpenseStatus($input: ToggleExpenseStatusInput) {
      toggle_expense_status(input: $input) {
        expense_id
      }
    }`,
    variables: {
      input: input
    }
  });
};

export const groupWalletTransfer = (input: GroupWalletTransferRequest) => {
  return client({
    query: `mutation GroupWalletTransfer($input: GroupWalletTransferInput) {
      group_wallet_transfer(input: $input) {
        group_pay_id
      }
    }`,
    variables: {
      input: input
    }
  });
};

export const connectUserToExpense = (input: ConnectUserToExpenseRequest) => {
  return client({
    query: `mutation ConnectUserToExpense($input: ConnectUserExpenseInput) {
      connect_user_to_expense(input: $input) {
        relationship_id
      }
    }`,
    variables: {
      input: input
    }
  });
};

export const removeUserFromExpense = (input: RemoveUserFromExpenseRequest) => {
  return client({
    query: `mutation RemoveUserFromExpense($input: RemoveUserExpenseInput) {
      remove_user_from_expense(input: $input) {
        expense_id
      }
    }`,
    variables: {
      input: input
    }
  });
};

export const getExpenseParticipants = (expense_id: string) => {
  return client({
    query: `query GetExpenseParticipants($input: ExpenseQueryInput) {
      get_expense_users(input: $input) {
        display_id
        email
        is_active
        user_id
        current_organisation_role
        roles {
          organisation_id
          value
        }
        attributes {
          first_name
          last_name
        }
      }
    }`,
    variables: {
      input: {
        expense_id: expense_id
      }
    }
  });
};
